var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-page",
        { attrs: { padding: "" } },
        [
          _c(
            "div",
            [
              _c("q-resize-observable", { on: { resize: _vm.onResize1 } }),
              _vm._v(" "),
              _vm.$route.params.parent_id
                ? _c("article-path", {
                    attrs: {
                      withoutLink: true,
                      id: _vm.$route.params.parent_id,
                      lbl: " "
                    }
                  })
                : _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: { "margin-right": "150px" }
                    },
                    [
                      _vm.tempItem.parent_id !== "root"
                        ? _c("q-btn", {
                            staticClass: "q-mr-sm",
                            attrs: {
                              round: "",
                              outline: "",
                              dense: "",
                              icon: "edit",
                              size: "sm",
                              color: "warning"
                            },
                            on: {
                              click: function($event) {
                                _vm.articleModalMode = 2
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("article-path", {
                        attrs: {
                          withoutLink: true,
                          id: _vm.tempItem.parent_id,
                          lbl: " "
                        }
                      })
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row q-mt-sm" },
                [
                  _vm.currentType !== "v"
                    ? _c(
                        "q-field",
                        {
                          staticClass: "col-sm-9 q-mr-md",
                          attrs: {
                            error: _vm.$v.tempItem.title.$error,
                            "error-label": _vm._f("errorLabel")(
                              _vm.$v.tempItem.title
                            )
                          }
                        },
                        [
                          _c("q-input", {
                            attrs: {
                              autofocus: true,
                              "float-label": "Заголовок"
                            },
                            model: {
                              value: _vm.tempItem.title,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.tempItem,
                                  "title",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tempItem.title"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentType !== "v"
                    ? _c(
                        "q-field",
                        { staticClass: "col-sm-2" },
                        [
                          _c("q-input", {
                            attrs: {
                              clearable: "",
                              type: "number",
                              decimals: 2,
                              step: 0.01,
                              min: "-1000",
                              max: "1000",
                              "float-label": "Порядок"
                            },
                            model: {
                              value: _vm._order,
                              callback: function($$v) {
                                _vm._order = $$v
                              },
                              expression: "_order"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentHasVariant
                ? _c(
                    "p",
                    [
                      _c("q-btn-toggle", {
                        attrs: {
                          outline: "",
                          rounded: "",
                          "text-color": "faded",
                          options: [
                            {
                              icon: "fas fa-file-alt",
                              value: "a",
                              toggleColor: "primary"
                            },
                            {
                              icon: "far fa-file-alt",
                              value: "v",
                              toggleColor: "warning"
                            }
                          ]
                        },
                        model: {
                          value: _vm.avtype,
                          callback: function($$v) {
                            _vm.avtype = $$v
                          },
                          expression: "avtype"
                        }
                      }),
                      _vm._v(" "),
                      _vm.avtype === "a"
                        ? _c("span", { staticClass: "text-primary" }, [
                            _vm._v("Опубликованный текст")
                          ])
                        : _c("span", { staticClass: "text-warning" }, [
                            _vm._v("Черновой текст")
                          ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("editor-menu-bar", {
                attrs: { editor: _vm.editor },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var commands = ref.commands
                      var isActive = ref.isActive
                      var menu = ref.menu
                      return _c(
                        "div",
                        { staticClass: "menubar row" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              attrs: { disabled: !_vm.undoEnabled },
                              on: { click: commands.undo }
                            },
                            [_c("q-icon", { attrs: { name: "undo" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              attrs: { disabled: !_vm.redoEnabled },
                              on: { click: commands.redo }
                            },
                            [_c("q-icon", { attrs: { name: "redo" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.bold() },
                              on: { click: commands.bold }
                            },
                            [_c("q-icon", { attrs: { name: "format_bold" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.italic() },
                              on: { click: commands.italic }
                            },
                            [
                              _c("q-icon", { attrs: { name: "format_italic" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.strike() },
                              on: { click: commands.strike }
                            },
                            [
                              _c("q-icon", {
                                attrs: { name: "strikethrough_s" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.underline() },
                              on: { click: commands.underline }
                            },
                            [
                              _c("q-icon", {
                                attrs: { name: "format_underlined" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.code() },
                              on: { click: commands.code }
                            },
                            [_c("q-icon", { attrs: { name: "code" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.paragraph() },
                              on: { click: commands.paragraph }
                            },
                            [_c("q-icon", { attrs: { name: "fa-paragraph" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: {
                                "is-active": isActive.heading({ level: 1 })
                              },
                              on: {
                                click: function($event) {
                                  commands.heading({ level: 1 })
                                }
                              }
                            },
                            [_vm._v("\n            H1\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: {
                                "is-active": isActive.heading({ level: 2 })
                              },
                              on: {
                                click: function($event) {
                                  commands.heading({ level: 2 })
                                }
                              }
                            },
                            [_vm._v("\n            H2\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: {
                                "is-active": isActive.heading({ level: 3 })
                              },
                              on: {
                                click: function($event) {
                                  commands.heading({ level: 3 })
                                }
                              }
                            },
                            [_vm._v("\n            H3\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.bullet_list() },
                              on: { click: commands.bullet_list }
                            },
                            [
                              _c("q-icon", {
                                attrs: { name: "format_list_bulleted" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.ordered_list() },
                              on: { click: commands.ordered_list }
                            },
                            [
                              _c("q-icon", {
                                attrs: { name: "format_list_numbered" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.blockquote() },
                              on: { click: commands.blockquote }
                            },
                            [_c("q-icon", { attrs: { name: "format_quote" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              class: { "is-active": isActive.code_block() },
                              on: { click: commands.code_block }
                            },
                            [_c("q-icon", { attrs: { name: "code" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              staticStyle: { position: "relative" }
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "q-uploader-input absolute-full cursor-pointer",
                                attrs: {
                                  type: "file",
                                  multiple: "",
                                  accept: "image/*"
                                },
                                on: { change: _vm.insertMedia }
                              }),
                              _vm._v(" "),
                              _c("q-icon", { attrs: { name: "image" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              staticStyle: { position: "relative" }
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "q-uploader-input absolute-full cursor-pointer",
                                attrs: {
                                  type: "file",
                                  multiple: "",
                                  accept: "video/*"
                                },
                                on: { change: _vm.insertMedia }
                              }),
                              _vm._v(" "),
                              _c("q-icon", { attrs: { name: "videocam" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              staticStyle: { position: "relative" }
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "q-uploader-input absolute-full cursor-pointer",
                                attrs: {
                                  type: "file",
                                  multiple: "",
                                  accept: "audio/*"
                                },
                                on: { change: _vm.insertMedia }
                              }),
                              _vm._v(" "),
                              _c("q-icon", { attrs: { name: "mic" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              staticStyle: { position: "relative" }
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "q-uploader-input absolute-full cursor-pointer",
                                attrs: {
                                  type: "file",
                                  multiple: "",
                                  accept: "*"
                                },
                                on: { change: _vm.insertMedia }
                              }),
                              _vm._v(" "),
                              _c("q-icon", {
                                attrs: { name: "fa fa-paperclip" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("editor-menu-bubble", {
                            attrs: { editor: _vm.editor },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var commands = ref.commands
                                  var isActive = ref.isActive
                                  var getMarkAttrs = ref.getMarkAttrs
                                  var menu = ref.menu
                                  return _c(
                                    "button",
                                    {
                                      staticClass: "menubar__button",
                                      attrs: { disabled: !menu.isActive },
                                      on: {
                                        click: function($event) {
                                          _vm.showLinkMenu(getMarkAttrs("link"))
                                        }
                                      }
                                    },
                                    [
                                      _c("q-icon", {
                                        attrs: { name: "fa-link" }
                                      })
                                    ],
                                    1
                                  )
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              attrs: { disabled: !_vm.emptySelection },
                              on: {
                                click: function($event) {
                                  _vm.articleModalMode = 1
                                }
                              }
                            },
                            [
                              _c("q-icon", {
                                attrs: { name: "fas fa-book-reader" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "menubar__button",
                              on: {
                                click: function($event) {
                                  commands.createTable({
                                    rowsCount: 3,
                                    colsCount: 3,
                                    withHeaderRow: false
                                  })
                                }
                              }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    viewBox: "0 0 24 24",
                                    id: "icon--table",
                                    width: "16px",
                                    height: "16px"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "fill-rule": "evenodd",
                                      d:
                                        "M17 17v5h2a3 3 0 0 0 3-3v-2h-5zm-2 0H9v5h6v-5zm2-2h5V9h-5v6zm-2 0V9H9v6h6zm2-8h5V5a3 3 0 0 0-3-3h-2v5zm-2 0V2H9v5h6zm9 9.177V19a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v2.823a.843.843 0 0 1 0 .354v7.646a.843.843 0 0 1 0 .354zM7 2H5a3 3 0 0 0-3 3v2h5V2zM2 9v6h5V9H2zm0 8v2a3 3 0 0 0 3 3h2v-5H2z"
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("editor-menu-bubble", {
                            attrs: { editor: _vm.editor },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var commands = ref.commands
                                  var isActive = ref.isActive
                                  var menu = ref.menu
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "menububble",
                                      class: { "is-active": isActive.table() },
                                      staticStyle: { left: "0px", top: "30px" }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          on: { click: commands.deleteTable }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--delete_table",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-2.5 5.938h5a.937.937 0 1 0 0-1.875h-5a.937.937 0 1 0 0 1.875zM12.29 17H9v5h3.674c.356.75.841 1.426 1.427 2H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v2.823a.843.843 0 0 1 0 .354V14.1a7.018 7.018 0 0 0-2-1.427V9h-5v3.29a6.972 6.972 0 0 0-2 .965V9H9v6h4.255a6.972 6.972 0 0 0-.965 2zM17 7h5V5a3 3 0 0 0-3-3h-2v5zm-2 0V2H9v5h6zM7 2H5a3 3 0 0 0-3 3v2h5V2zM2 9v6h5V9H2zm0 8v2a3 3 0 0 0 3 3h2v-5H2z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          on: {
                                            click: commands.addColumnBefore
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--add_col_before",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm2.5 5.938a.937.937 0 1 0 0-1.875h-1.25a.312.312 0 0 1-.313-.313V16.5a.937.937 0 1 0-1.875 0v1.25c0 .173-.14.313-.312.313H16.5a.937.937 0 1 0 0 1.875h1.25c.173 0 .313.14.313.312v1.25a.937.937 0 1 0 1.875 0v-1.25c0-.173.14-.313.312-.313h1.25zM2 19a3 3 0 0 0 6 0V5a3 3 0 1 0-6 0v14zm-2 0V5a5 5 0 1 1 10 0v14a5 5 0 0 1-10 0z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          on: { click: commands.addColumnAfter }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--add_col_after",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M5 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm2.5 5.938a.937.937 0 1 0 0-1.875H6.25a.312.312 0 0 1-.313-.313V16.5a.937.937 0 1 0-1.875 0v1.25c0 .173-.14.313-.312.313H2.5a.937.937 0 1 0 0 1.875h1.25c.173 0 .313.14.313.312v1.25a.937.937 0 1 0 1.875 0v-1.25c0-.173.14-.313.312-.313H7.5zM16 19a3 3 0 0 0 6 0V5a3 3 0 0 0-6 0v14zm-2 0V5a5 5 0 0 1 10 0v14a5 5 0 0 1-10 0z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          on: { click: commands.deleteColumn }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--delete_col",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M12.641 21.931a7.01 7.01 0 0 0 1.146 1.74A5 5 0 0 1 7 19V5a5 5 0 1 1 10 0v7.29a6.972 6.972 0 0 0-2 .965V5a3 3 0 0 0-6 0v14a3 3 0 0 0 3.641 2.931zM19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-2.5 5.938h5a.937.937 0 1 0 0-1.875h-5a.937.937 0 1 0 0 1.875z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          on: { click: commands.addRowBefore }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--add_row_before",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm2.5 5.938a.937.937 0 1 0 0-1.875h-1.25a.312.312 0 0 1-.313-.313V16.5a.937.937 0 1 0-1.875 0v1.25c0 .173-.14.313-.312.313H16.5a.937.937 0 1 0 0 1.875h1.25c.173 0 .313.14.313.312v1.25a.937.937 0 1 0 1.875 0v-1.25c0-.173.14-.313.312-.313h1.25zM5 2a3 3 0 1 0 0 6h14a3 3 0 0 0 0-6H5zm0-2h14a5 5 0 0 1 0 10H5A5 5 0 1 1 5 0z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          on: { click: commands.addRowAfter }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--add_row_after",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M19 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm2.5 5.938a.937.937 0 1 0 0-1.875h-1.25a.312.312 0 0 1-.313-.313V2.5a.937.937 0 1 0-1.875 0v1.25c0 .173-.14.313-.312.313H16.5a.937.937 0 1 0 0 1.875h1.25c.173 0 .313.14.313.312V7.5a.937.937 0 1 0 1.875 0V6.25c0-.173.14-.313.312-.313h1.25zM5 16a3 3 0 0 0 0 6h14a3 3 0 0 0 0-6H5zm0-2h14a5 5 0 0 1 0 10H5a5 5 0 0 1 0-10z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          on: { click: commands.deleteRow }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--delete_row",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M13.255 15a6.972 6.972 0 0 0-.965 2H5A5 5 0 0 1 5 7h14a5 5 0 0 1 4.671 6.787 7.01 7.01 0 0 0-1.74-1.146A3 3 0 0 0 19 9H5a3 3 0 0 0 0 6h8.255zM19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-2.5 5.938h5a.937.937 0 1 0 0-1.875h-5a.937.937 0 1 0 0 1.875z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          on: {
                                            click: commands.toggleCellMerge
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--combine_cells",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M2 19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v14zm-2 0V5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5zm12-9a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1zm0-13a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          class: {
                                            "is-active": isActive.table_header()
                                          },
                                          on: {
                                            click: commands.toggleHeaderColumn
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--add_col_before",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  stroke: "black",
                                                  "stroke-width": "1",
                                                  fill: "gray",
                                                  d:
                                                    "M 6 19 a 3 3 0 0 0 6 0 V 5 a 3 3 0 1 0 -6 0 v 14 z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menubar__button",
                                          class: {
                                            "is-active": isActive.table_header()
                                          },
                                          on: {
                                            click: commands.toggleHeaderRow
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 24 24",
                                                id: "icon--add_col_before",
                                                width: "16px",
                                                height: "16px"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  stroke: "black",
                                                  "stroke-width": "1",
                                                  fill: "gray",
                                                  d:
                                                    "M5 2a3 3 0 1 0 0 6h14a3 3 0 0 0 0-6H5z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "editor",
              style: { "max-height": _vm.contentMaxHeight }
            },
            [
              _c("editor-content", {
                staticClass: "editor__content",
                attrs: { editor: _vm.editor }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.currentType !== "v"
            ? _c(
                "q-field",
                [
                  _c("q-resize-observable", { on: { resize: _vm.onResize2 } }),
                  _vm._v(" "),
                  _c("q-chips-input", {
                    attrs: {
                      "add-icon": "add_circle_outline",
                      "float-label": "Тэги"
                    },
                    model: {
                      value: _vm.tempItem.tags,
                      callback: function($$v) {
                        _vm.$set(_vm.tempItem, "tags", $$v)
                      },
                      expression: "tempItem.tags"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("publish-btn", {
            attrs: {
              type: _vm.currentType,
              notChanged: _vm.notChanged,
              goView: _vm.goView,
              doSave: _vm.saveDraft,
              doPublish: _vm.saveArt
            }
          }),
          _vm._v(" "),
          _c(
            "q-modal",
            {
              on: {
                show: function($event) {
                  _vm.$refs.linkInput.focus()
                }
              },
              model: {
                value: _vm.linkModalActive,
                callback: function($$v) {
                  _vm.linkModalActive = $$v
                },
                expression: "linkModalActive"
              }
            },
            [
              _c(
                "form",
                { staticClass: "group" },
                [
                  _c("q-input", {
                    ref: "linkInput",
                    attrs: {
                      type: "url",
                      "float-label": "Адрес ссылки",
                      placeholder: "http:\\\\",
                      clearable: ""
                    },
                    model: {
                      value: _vm.linkUrl,
                      callback: function($$v) {
                        _vm.linkUrl = $$v
                      },
                      expression: "linkUrl"
                    }
                  }),
                  _vm._v(" "),
                  _c("q-checkbox", {
                    attrs: { label: "В новом окне" },
                    model: {
                      value: _vm.linkInNew,
                      callback: function($$v) {
                        _vm.linkInNew = $$v
                      },
                      expression: "linkInNew"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-buttons row" },
                    [
                      _c(
                        "q-btn",
                        {
                          staticClass: "pull-right",
                          attrs: { flat: "", color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.linkModalActive = false
                            }
                          }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "q-btn",
                        {
                          staticClass: "pull-right",
                          attrs: { flat: "", color: "warning" },
                          on: { click: _vm.setLinkUrl }
                        },
                        [_vm._v("\n          Сохранить\n        ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "q-modal",
            {
              attrs: { "content-classes": "group" },
              model: {
                value: _vm.articleModalActive,
                callback: function($$v) {
                  _vm.articleModalActive = $$v
                },
                expression: "articleModalActive"
              }
            },
            [
              _vm.articleModalMode === 1
                ? _c("h6", [_vm._v("Ссылка на статью")])
                : _c("h6", [_vm._v("Новое расположение статьи")]),
              _vm._v(" "),
              _c("tree-wiki", {
                attrs: {
                  withDraft: false,
                  done: _vm.articleLinkDone,
                  disabledNode: _vm.avId,
                  disabledNotExpandable: _vm.articleModalMode === 2
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c(
                    "q-btn",
                    {
                      attrs: { flat: "", color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.articleModalActive = false
                        }
                      }
                    },
                    [_vm._v("Отменить")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("media-inserter", {
        ref: "mediainserter",
        attrs: { editEnabled: true },
        on: { mediaSaved: _vm.mediaSaved, doNext: _vm.doNext }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3abb5059", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3abb5059","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wiki-edit.vue
// module id = null
// module chunks = 